import { reportColumnAggregateTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import mean from "lodash/mean";
import sum from "lodash/sum";
import React from "react";
import { list as trucksList } from "sources/books/trucks";
import CommonReport from "./commonReport";

export default class AverageTonnageReport extends CommonReport {
    extractColumns = () => {
        const { columns } = this.props.data || {};
        return columns.map((column) => {
            return {
                Header: column.label,
                accessor: columnName(column),
                Cell: (props) => {
                    switch (props.column.id) {
                        case "carId": {
                            const { subRows } = props.row;
                            const { car } = subRows[0].original;
                            return <span data-car={car}>{car}</span>;
                        }
                        case "bidId": {
                            return (
                                <a
                                    data-bidid={props.value}
                                    href={paths.bidShow("bid", props.value)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {props.value}
                                </a>
                            );
                        }
                        default: {
                            const { bidId } = props.row.values;
                            const uniqueId = { [`data-${props.column.id}`.toLowerCase()]: bidId };
                            return <div {...uniqueId}>{formatValue(props.value, column.clrType)}</div>;
                        }
                    }
                },
                Footer: () => this.footerVal(column),
                aggregate: (values) => {
                    if (!this.numericClrTypes.includes(column.clrType)) {
                        return null;
                    }
                    switch (column.aggregateType) {
                        case reportColumnAggregateTypesEnum.Average:
                            return Math.round(mean(values));
                        case reportColumnAggregateTypesEnum.Sum:
                            return sum(values);
                        default:
                            return null;
                    }
                },
                Aggregated: ({ value }) => {
                    return value !== null ? <strong>{formatValue(value, column.clrType)}</strong> : "";
                },
                ...this.columnFilters(column),
            };
        });
    };

    columnFilters = (column) => {
        if (column.propertyName === "CarId") {
            return {
                filterable: true,
                Filter: reportFilterWrapper((props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ url: trucksList, inputProps: { name: "carId" }, propName: "number" }}
                    />
                )),
                filter: (rows, _id, filterValue) => {
                    if (!filterValue || !filterValue.value) {
                        return rows;
                    }
                    return rows.filter((row) => row.values.carId === filterValue.value);
                },
            };
        } else {
            return column.propertyName === "BidId"
                ? typeSpecificProps({ clrType: "default" })
                : typeSpecificProps(column);
        }
    };

    tableExtraProps = () => {
        const { columns } = this.props.data || {};
        const hiddenColumns = columns
            .filter((column) => column.isAdditionalColumn || column.isFooterData || column.propertyName === "Car")
            .map(columnName);
        return {
            initialState: {
                hiddenColumns,
                groupBy: ["carId"],
            },
        };
    };
}
